<template>
    <span>{{ formattedDate }}</span>
</template>

<script lang="ts">

export default {
    props: ['params'],
    computed: {
        formattedDate() {
            const durationInMinutes: number  = this.params.value;
            if (durationInMinutes) {
                const hours = Math.floor(durationInMinutes / 60);
                const minutes = Math.round(durationInMinutes % 60);
                const formattedHours =  hours ? `${hours}h ` : '';
                // const formattedMinutes = minutes.toString().padStart(2, '0');
                const formattedMinutes = minutes ? `${minutes.toString().padStart(2, '0')}min` : '';
                return `${formattedHours}${formattedMinutes}`;
            }
            return '';
        }
    }
};
</script>

<style scoped lang="scss">

</style>